module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAA6UlEQVQ4jbWUMQrCQBBFnyFuqSQHEAsLkRzIwpRWgp2X0DqdnY23sLG0FFFIYTxARBtxbSw0EuIk7Ar+cpd5+2f+MrXVeqOAGTAAfOx0BhbAxAWmvtcYdzttlKpbUbR+ePv4OE7P15sDhL9AAJSq0+20AYYO4EuQaHsxhgG+I11G24sxKJNbBektT2LRrt/6OhMd/aIvR6Og+XEmvWwMysNsVNqaBKsKwGpGVWmKrZWllXdVdPy/1ED+J/ByOgqa4vysHJVBMlCq9cMYVNS7NnWAxSFOMIXlddeaQ5wAzGu5xRYCniXrs9ieLghSpHhag98AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dash-btn1.png
// module id = T/J5
// module chunks = 1